module.exports = __webpack_public_path__ + "static/tracer-building-99adbbcfc54762178c37463be6ab5084.png";